import { findIndex, includes } from 'lodash';
import { connect } from 'react-redux';

import PdpCarousel from 'components/PdpCarousel';
import * as actions from 'state/actions';
import {
  getSlides,
  getContentfulPoweredSlides,
  getCurrentProductHandle,
  getCurrentMainCarouselSlide,
  getProductModelDescription,
  getExperimentImagesLoading,
} from 'state/selectors/pdp';
import Rudderstack from 'utils/Rudderstack';

const mapStateToProps = (state, ownProps) => {
  const currentProductHandle = getCurrentProductHandle(state);
  const isLoading = getExperimentImagesLoading(state);
  const slides = getSlides(state);
  const contentfulPoweredSlides = getContentfulPoweredSlides(state);
  const currentMainCarouselSlide = getCurrentMainCarouselSlide(state);

  const modelDescription = getProductModelDescription(state);

  const labeledModelImageIndex = findIndex(contentfulPoweredSlides, ({ tags }) =>
    includes(tags, 'imageTypeModelShot')
  );

  return {
    slides: slides.slice(0, 8),
    currentMainCarouselSlide,
    currentProductHandle,
    modelDescription,
    labeledModelImageIndex,
    isLoading,
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleZoomButtonClick: index => {
    dispatch(actions.setPdpZoomViewGridIndex(index));

    Rudderstack.productImageClick({
      index,
      product: ownProps.product,
    });
  },
  setCurrentMainCarouselSlide: index => {
    dispatch(actions.setCurrentMainCarouselSlide(index));
    Rudderstack.productImageScroll({
      index,
      product: ownProps.product,
    });
  },
});

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(PdpCarousel);
